import React, { FormEvent } from 'react'
import { serializeForm, submitForm } from '@sitecore-jss/sitecore-jss-forms'
import { Form } from '@sitecore-jss/sitecore-jss-react-forms'
import { connect } from 'react-redux'
import {
  updateFields,
  setLoader,
  updateRemoveError,
  updateCustomError,
} from '../../../ReduxImpl/actions/index'

export interface FieldState {
  value?: string | string[] | File[] | boolean
  isValid: boolean
  errors: string[]
}

export interface FieldStateCollection {
  [key: string]: FieldState
}

class JssForm extends Form {
  delayScroll(time = 2000) {
    setTimeout(() => {
      window?.scroll(0, 0)
    }, time)
  }

  getCookieValue(name) {
    let result = document && document.cookie.match(
      '(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)'
    )
    return result ? result.pop() : ''
  }

  /**
   * Handler triggered when the form is submitted. May transition its state between
   * steps in a multistep form or handle a final submit.
   * @param {FormEvent} e
   */
  onSubmit(e: FormEvent) {
    e.preventDefault()

    let jssForm: any = this.props
    jssForm.setLoader(true)

    let rError: any = this.props
    rError.updateRemoveError(true)

    let cError: any = this.props
    cError.updateCustomError('')

    const form = this.state.nextForm || this.props.form

    const fieldValues: { [key: string]: string | string[] | boolean | File[] } =
      {}

    const currentFieldValues = this.collectCurrentFieldValues()

    currentFieldValues.forEach((field) => {
      if (typeof field.state.value !== 'undefined') {
        fieldValues[field.fieldName] = field.state.value
      }
    })

    // NOTE: we're not pre-validating the submit on the client because
    // Sitecore won't be able to track validation errors in xConnect

    // serialize the form data that we got from the server
    // (hidden fields with constant values, unchanged default field values, etc)
    const formData = serializeForm(form, {
      submitButtonName: this.state.submitButton,
    })


 

    // add cookie language 
    let languageSelected = this.getCookieValue("cnhicorporate#lang2") ? this.getCookieValue("cnhicorporate#lang2") : 'en-US';
 

    function findElementWithCSSClass(obj, name) { 
      if (obj.model && obj.model.name === name) {
        return obj;
      }
    
      if (obj.fields && obj.fields.length > 0) {
        for (const field of obj.fields) {
          const foundElement = findElementWithCSSClass(field, name);
          if (foundElement) {
            return foundElement;
          }
        }
      }
    
      return null;
    }
     
 

    const elementWithCSSClass = findElementWithCSSClass(form, "LanguageDropdownList"); 
 
    if(elementWithCSSClass){
      fieldValues[elementWithCSSClass.valueField.name] = languageSelected ?? ''; 
    }  

// end language selected add

     

    // merge in user-updated field values
    formData.mergeOverwritingExisting(fieldValues) 

    const submitUrl =
      (e.target as HTMLFormElement).action +
        '&sc_lang=' +
        (this.getCookieValue('cnhicorporate#lang2') ? this.getCookieValue('cnhicorporate#lang2') : 'en-US')

    if (!submitUrl) {
      throw new Error(
        'Submit URL was not defined. Ensure the form has an action attribute.'
      )
    }

    submitForm(formData, submitUrl, { fetcher: this.props.formFetcher })
      .then((result) => {
        if (result.success && result.redirectUrl) {
          // Process redirect-on-success action.
          if (this.props.onRedirect) {
            this.props.onRedirect(result.redirectUrl)
          } else {
            if (typeof window !== 'undefined') {
              window.location.href = result.redirectUrl
            }
          }
        }

        let ErrorElToBeFocused: string

        if (result.validationErrors) {
          if (Object.keys(result.validationErrors).length > 0) {
            const stateUpdate: FieldStateCollection = {}

            Object.keys(result.validationErrors).forEach((fieldKey) => {
              if (!ErrorElToBeFocused) ErrorElToBeFocused = fieldKey

              stateUpdate[fieldKey] = {
                value: (this.state[fieldKey] || {}).value,

                isValid: false,

                errors: result.validationErrors[fieldKey],
              }
            })
            // --- sets the Frist Error Element on form after submit ---

            this.setState(stateUpdate, () => {
              const fieldEl: HTMLElement | null = document.querySelector(
                "*[name='" + ErrorElToBeFocused + "']"
              )

              fieldEl?.focus()
            })
          }
        }

        if (result.nextForm) {
          let sampleProps: any = this.props
          sampleProps.updateFields(result.nextForm)
        }

        if (result.success) {
          this.resetFieldsState()
        }
        // --- checks for email address already exits -> subscribe form ---
        if (
          result.success &&
          result.redirectUrl === null &&
          result.validationErrors
        ) {
          rError.updateRemoveError(true)
          throw result.errors[0]
        }

        if (result.errors && result.errors.length > 0) {
          throw result.errors
        }

        jssForm.setLoader(false)
        this.setState({ errors: [] })
      })
      .catch((error: Error | string[] | string) => {
        if (Array.isArray(error)) {
          this.setState({ errors: error })
        } else if (typeof error === 'string') {
          cError.updateCustomError(error)

          this.setState({ errors: [error] })
        } else {
          this.setState({ errors: [error?.message] })
        }

        jssForm.setLoader(false)
        rError.updateRemoveError(true)
      })
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateFields: (fields) => dispatch(updateFields(fields)),
    setLoader: (val) => dispatch(setLoader(val)),
    updateRemoveError: (v) => dispatch(updateRemoveError(v)),
    updateCustomError: (c) => dispatch(updateCustomError(c)),
  }
}

export default connect(null, mapDispatchToProps)(JssForm)
